import React, { useEffect, useState } from "react";
import {
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaGithub,
  FaTiktok,
} from "react-icons/fa6";
import AboutBanner from "../assets/media/Trip2.b83b5d6c64ad2114fc65.jpg";
import HeaderLogo from "../assets/media/logo02.jpeg";
import axios from "axios";
import AboutUsAPI from "../api/AboutUsAPI";
import OurTeamAPI from "../api/OurTeamAPI";
import TravelersIcon from "../assets/media/icons/traveler.png";
import SuccessFullTripIcon from "../assets/media/icons/road-trip.png";
import BikeIcon from "../assets/media/icons/motorcycle.png";
import CorporateIcon from "../assets/media/icons/manager.png";
import OrganizedFileIcon from "../assets/media/icons/database-file.png";
import ReviewsIcon from "../assets/media/icons/customer-review.png";

const About = () => {
  let [aboutData, setAboutData] = useState({});
  let [teamData, setTeamData] = useState([]);

  const [error, setError] = useState(null);
  // Function to get social media icon based on URL
  const getSocialIcon = (url) => {
    if (!url || typeof url !== "string") return null; // ⚡ safety check

    const lowerUrl = url.toLowerCase();

    if (lowerUrl.includes("linkedin")) {
      return <FaLinkedin className="custom-about-card-social-icon" />;
    } else if (lowerUrl.includes("twitter") || lowerUrl.includes("x.com")) {
      return <FaTwitter className="custom-about-card-social-icon" />;
    } else if (lowerUrl.includes("facebook")) {
      return <FaFacebook className="custom-about-card-social-icon" />;
    } else if (lowerUrl.includes("instagram")) {
      return <FaInstagram className="custom-about-card-social-icon" />;
    } else if (lowerUrl.includes("youtube")) {
      return <FaYoutube className="custom-about-card-social-icon" />;
    } else if (lowerUrl.includes("github")) {
      return <FaGithub className="custom-about-card-social-icon" />;
    } else if (lowerUrl.includes("tiktok")) {
      return <FaTiktok className="custom-about-card-social-icon" />;
    } else {
      return null; // ya ek default icon
    }
  };

  // Function to parse social media URLs
  const parseSocialMedia = (socialMediaString) => {
    try {
      return JSON.parse(socialMediaString);
    } catch (error) {
      console.error("Error parsing social media:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await AboutUsAPI.getAboutUs();
        if (res.code === 200) {
          setAboutData(res.data || {});
        }

        const teamRes = await OurTeamAPI.getOurTeam();
        if (teamRes.code === 200) {
          setTeamData(teamRes.data || []);
        }
      } catch (err) {
        console.error("Error:", err);
        setError("Unable to load data.");
      }
    };

    fetchData();
  }, []);

  const items = [
    {
      icon: TravelersIcon,
      label: "Engaging, experienced trip leaders",
    },
    {
      icon: SuccessFullTripIcon,
      label: "⁠Pan-India family, corporate & group tours",
    },
    {
      icon: BikeIcon,
      label: "Proactive, dedicated support",
    },
    {
      icon: CorporateIcon,
      label: "⁠Safety-led travel planning",
    },
    {
      icon: OrganizedFileIcon,
      label: "⁠Tried & tested, seamless itineraries",
    },
    {
      icon: ReviewsIcon,
      label: "⁠Locally vetted, trusted stays",
    },
  ];

  return (
    <section className="custom-about-section container-fluid px-0">
      <div className="row m-0 w-100">
        {/* Features Banner Section */}
        <div className="col-12 p-0 mb-3 d-flex justify-content-center align-items-center custom-about-banner-box">
          <div className="w-100 h-100 d-flex justify-content-center align-items-center pt-2">
            <div className="w-100 custom-about-new-container">
              <div className="row justify-content-center align-items-center m-0">
                {items.map((item, idx) => (
                  <div
                    key={idx}
                    className="col-6 col-md-3 col-lg-2 d-flex flex-column align-items-center justify-content-start"
                    style={{ minHeight: "160px" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        background: "#fff",
                        marginBottom: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt=""
                        style={{
                          width: "30px",
                          height: "30px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <p
                      className="fw-bold text-secondary text-center custom-about-icons-text"
                      style={{ maxWidth: "150px" }}
                    >
                      {item.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* About Text Content */}
        <div className="col-12 pt-5">
          <div className="row justify-content-center m-0">
            <div className="col-12 col-lg-10 col-xl-8 px-3 px-md-4 custom-about-text-content">
              <h3 className="text-center mb-4 text-uppercase fw-bold">
                What do we stand for and how did we reach to it?
              </h3>
              <div
                // className="text-center"
                style={{
                  maxWidth: "100%",
                  lineHeight: "1.6",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={{ __html: aboutData.description }}
              />
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="col-12 custom-about-bottom-part mt-4">
          <div className="row justify-content-center m-0">
            <div className="col-12 col-lg-10 col-xl-8 px-3 px-md-4">
              <h3
                className="py-3 mb-4 pt-4 fw-bold"
                style={{ textAlign: "center" }}
              >
                Meet Our Team - The ideal set of extraordinary people
              </h3>

              <div className="row justify-content-center m-0 gap-4 gap-md-5">
                {Array.isArray(teamData) &&
                  teamData.map((member) => {
                    const socialMediaLinks = member?.social_media
                      ? parseSocialMedia(member.social_media)
                      : [];

                    return (
                      <div
                        key={member.id}
                        className="col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4 custom-about-card"
                      >
                        <div className="custom-about-logo text-center mb-3">
                          <img
                            src={
                              member?.image
                                ? `https://sortedtrips.in/admin/${member.image}`
                                : HeaderLogo
                            }
                            alt={member?.name || "Team Member"}
                            className="img-fluid"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <h4
                          className="text-center fw-bold mb-2"
                          style={{ fontFamily: "nexaBold" }}
                        >
                          {member?.name || ""}
                        </h4>
                        <h6 className="text-center text-muted mb-3">
                          {member?.designation || ""}
                        </h6>

                        {socialMediaLinks.length > 0 && (
                          <div className="custom-about-social-box">
                            {socialMediaLinks.map((socialUrl, index) =>
                              socialUrl ? ( // only render if not null
                                <a
                                  key={index}
                                  href={socialUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {getSocialIcon(socialUrl)}
                                </a>
                              ) : null
                            )}
                          </div>
                        )}

                        {member?.description && (
                          <p
                            className="px-3 mt-3 text-muted text-center"
                            style={{
                              fontSize: "0.9rem",
                              fontFamily: "nexaLight",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: member.description,
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="col-12 d-flex flex-column justify-content-center align-items-center mt-5 mb-5">
          <div className="row justify-content-center w-100 m-0">
            <div className="col-12 col-lg-10 col-xl-8 px-3 px-md-4">
              <h2
                className="text-center py-2 pt-3 fw-bold"
                style={{ fontFamily: "nexaBold" }}
              >
                Values we strive for :
              </h2>
              <p
                className="custom-about-last-content py-3"
                style={{ lineHeight: "1.6" }}
                dangerouslySetInnerHTML={{ __html: aboutData.Values_strive }}
              >
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
